<template>
  <div class="app flex-row align-items-center">
    <vue-headful :title="`Logowanie - Leadzard`" />
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <form class="login" @submit.prevent="login">
                <b-card-body>
                  <h1>Zaloguj się</h1>
                  <p class="text-muted"></p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <input type="text" required v-model="username" class="form-control" placeholder="Użytkownik" autocomplete="on">
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <input type="password" required v-model="password" class="form-control" placeholder="Hasło" autocomplete="on">
                  </b-input-group>
                    <p class="alert alert-danger" v-if="error">{{ error }}</p>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="primary" class="px-4 bg-ocmd-blue">Zaloguj</b-button>
                    </b-col>
                  </b-row>
                </b-card-body>
              </form>
            </b-card>
            <b-card no-body class="text-white bg-ocmd-blue py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Leadzard</h2>
                  <p>System do zarządzania leadami</p>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import auth from '../../auth'
import vueHeadful from 'vue-headful'

export default {
  data () {
    return {
      username: '',
      password: '',
      error: ''
    }
  },
  name: 'p-login',
  components: {
    vueHeadful
  },
  props: ['redirectedFrom'],
  beforeCreate () {
    if (auth.user.authenticated) {
      this.$router.push('/')
    }
  },
  methods: {
    login: function () {
      const credentials = {
        username: this.username,
        password: this.password
      }
      const redirectTo = localStorage.getItem('redirectTo') || '/'
      localStorage.removeItem('redirectTo')
      auth.login(this, credentials, redirectTo)
    }
  }
}
</script>
